module.exports = "/static/assets/57a47b7ba3befc2a2e324716b85048b8.png";